import type { RouteRecordRaw } from 'vue-router';
import { depositRoutesDictionary } from './deposit-routes.dictionary';

export const depositRoutesConfig: RouteRecordRaw = {
  ...depositRoutesDictionary.deposit.root,
  redirect: { name: depositRoutesDictionary.deposit.list.name },
  children: [
    {
      ...depositRoutesDictionary.deposit.list,
      component: () => import('../pages/List/DepositListPage.vue'),
    },
  ],
};
